import {Component, OnInit, Inject} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';
import {MemberLink} from 'src/app/models/member-link';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-member-links-dialog',
  templateUrl: './member-links-dialog.component.html',
  styleUrls: [ './member-links-dialog.component.scss' ]
})
export class MemberLinksDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();
  public linkForm: FormGroup;
  public isEdit: boolean

  constructor (
    private fb: FormBuilder,
    public matDialogRef: MatDialogRef<MemberLinksDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MemberLink
  ) {

    if (this.data.id == '0') {
      this.isEdit = false
    } else {
      this.isEdit = true
    }
    this.linkForm = this.createLinkForm(this.data)
  }

  ngOnInit () {

  }

  createLinkForm (data) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      text: new FormControl(data.text, [ Validators.required ]),
      date: new FormControl(data.date, [ Validators.required ]),
      link: new FormControl(data.link, [ Validators.required ]),
      member_id: new FormControl(data.member_id),
      member_name: new FormControl(data.member_name)
    });
    return form
  }

}
